import React from 'react';

import PanelConfigurationContext from './PanelConfiguration.context';
import PanelConfigurationView from './PanelConfiguration.view';

const PanelConfiguration = props => (
  <PanelConfigurationContext>
    <PanelConfigurationView {...props} />
  </PanelConfigurationContext>
);

export default PanelConfiguration;
